module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/sola_symbol-32b3dad116b01b680af93f22ec6c46bc.svg";